/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Clear_ButtonInputs */

const en_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const fr_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer`)
};

const de_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

const it_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiaro`)
};

const ru_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачный`)
};

const es_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

const zh_cn2_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除`)
};

const ja_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア`)
};

const hi_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पष्ट`)
};

const pt_pt2_speaker_manager_clear_button = /** @type {(inputs: Speaker_Manager_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Speaker_Manager_Clear_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_clear_button = /** @type {((inputs?: Speaker_Manager_Clear_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Clear_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_clear_button(inputs)
	if (locale === "de") return de_speaker_manager_clear_button(inputs)
	if (locale === "it") return it_speaker_manager_clear_button(inputs)
	if (locale === "ru") return ru_speaker_manager_clear_button(inputs)
	if (locale === "es") return es_speaker_manager_clear_button(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_clear_button(inputs)
	if (locale === "ja") return ja_speaker_manager_clear_button(inputs)
	if (locale === "hi") return hi_speaker_manager_clear_button(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_clear_button(inputs)
	return en_speaker_manager_clear_button(inputs)
});